import script from "./HeroTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroTitle.vue?vue&type=script&setup=true&lang=ts"

import "./HeroTitle.vue?vue&type=style&index=0&id=d7b5a43e&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7b5a43e"]])

export default __exports__